import React from 'react';
import Modal from '../../../../../components/Modal';
import Table from '../../../../../components/_table/Table';
import OpenDeliveryAgentList from '../../../../../containers/app/common/OpenDeliveryAgentListContainer';
import columns from './columns';
import './CheckExcelBulkDeliveryDispatchResultModal.scss';

const CheckExcelBulkDeliveryDispatchResultModal = (props) => {
  const {
    isOpen,
    data,
    filteredList,
    filteredStoreId,
    filteredOrderItemId,
    filteredInvoiceNumber,
    onFilter,
    closeModal,
  } = props;
  const { excelBulkDeliveryInfoSummary } = data;

  return (
    <Modal
      title="엑셀 일괄 발송 처리 유효성 체크 결과"
      isOpen={isOpen}
      width={1000}
      height={600}
      isFooter={true}
      okText="확인"
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="check-excel-bulk-delivery-dispatch-result-modal-wrap">
        <div className="check-excel-bulk-delivery-dispatch-result-summary">
          <span className="request">
            전체 요청건 수:
            <span>{excelBulkDeliveryInfoSummary.requestCnt}</span>
          </span>
          <span className="valid">
            가능건 수:
            <span>{excelBulkDeliveryInfoSummary.validCnt}</span>
          </span>
          <span className="invalid">
            불가능건 수:
            <span>{excelBulkDeliveryInfoSummary.invalidCnt}</span>
          </span>
        </div>

        <div className="check-excel-bulk-delivery-dispatch-result-info">
          <div className="info">엑셀 일괄 발송 처리를 실패했습니다. </div>
          <div className="info">
            아래 리스트에서 실패한 결과를 확인하시고, 수정을 한 뒤 다시 엑셀 파일을 업로드하시기 바랍니다.
          </div>
          <br />
          <div className="emphasize">
            * <span className="bold">상품 주문 번호는 필수</span> 값이며, <span className="bold">최대 50자</span> 까지
            숫자만 입력 가능합니다.
          </div>
          <div className="emphasize">
            * <span className="bold">배송 방법은 필수</span> 값이며, 아몬즈에서 사용하고 있는{' '}
            <span className="bold">'택배, 등기, 소포', '직접전달', '방문수령', '퀵서비스', '기타방법'</span> 만 입력
            가능합니다.
          </div>
          <div className="emphasize">
            * <span className="bold">택배사</span> 는 배송 방법이{' '}
            <span className="bold">'택배, 등기, 소포'일 때 필수</span> 값이며, 아몬즈에서 사용하고 있는 택배사만 입력
            가능합니다.
            <OpenDeliveryAgentList />
          </div>
          <div className="emphasize">
            * <span className="bold">송장번호</span> 는 배송 방법이{' '}
            <span className="bold">'택배, 등기, 소포'일 때 필수</span> 값이며, <span className="bold">최대 30자</span>{' '}
            까지 <span className="bold">숫자만 입력 가능</span> 합니다.
          </div>
        </div>

        <Table
          rowKey={(record) => record.id || new Date().getTime()}
          list={filteredList}
          scroll={{ x: true }}
          rowClassName={(record) =>
            record.orderItemIdInvalidTypeList ||
            record.deliveryTypeInValidTypeList ||
            record.deliveryAgentNameInValidTypeList ||
            record.invoiceNumberInvalidTypeList
              ? 'is-fail'
              : ''
          }
          columns={() =>
            columns({
              filteredStoreId,
              filteredOrderItemId,
              filteredInvoiceNumber,
              onFilter,
            })
          }
        />
      </div>
    </Modal>
  );
};

export default CheckExcelBulkDeliveryDispatchResultModal;
